import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-internalFreeTypeShape",
  "use": "svg-icon-internalFreeTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-internalFreeTypeShape\"><g fill=\"#000\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.872 0a.5.5 0 0 0-.485.379L7.982 2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.982l-.345 1.379a.5.5 0 0 0 .485.621h1.245a.5.5 0 0 0 .485-.379l3.75-15A.5.5 0 0 0 10.117 0H8.872zm-3.39 12l2-8H2v8h3.482z\" /><path d=\"M9.46 12H14V4h-2.54l.5-2H14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8.96l.5-2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol